var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Layer_4",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.453,22.41h7.707c0.969,0,1.764-0.724,1.893-1.657c0.851-0.396,1.446-1.255,1.446-2.254v-0.614  c0-0.276-0.224-0.5-0.5-0.5s-0.5,0.224-0.5,0.5v0.614c0,0.822-0.669,1.491-1.491,1.491H8.001c-0.828,0-1.501-0.673-1.501-1.501  V5.501c0-0.822,0.669-1.491,1.491-1.491h5.663c-0.021,0.072-0.034,0.147-0.034,0.225V6.88c0,0.557,0.453,1.01,1.01,1.01h2.646  c0.078,0,0.153-0.013,0.225-0.033v1.44v6.87c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-6.87V7.39  c0-0.133-0.053-0.26-0.146-0.354l-0.511-0.511c0,0-0.001-0.001-0.001-0.002l-1.428-1.427l-1.94-1.94  C14.38,3.063,14.253,3.01,14.12,3.01H7.991c-1,0-1.857,0.595-2.254,1.447C4.804,4.586,4.08,5.382,4.08,6.35v2.9  c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-2.9c0-0.323,0.167-0.608,0.42-0.772v12.911v0.01c0,1.374,1.117,2.491,2.491,2.491  h0.01h7.931c-0.164,0.252-0.449,0.42-0.772,0.42H7.453c-1.309,0-2.373-1.065-2.373-2.374v-8.068c0-0.276-0.224-0.5-0.5-0.5  s-0.5,0.224-0.5,0.5v8.068C4.08,20.897,5.593,22.41,7.453,22.41z M14.62,4.717l1.087,1.086l1.086,1.087H14.63  c-0.005,0-0.01-0.004-0.01-0.01V4.717z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.417,12c0-0.276-0.224-0.5-0.5-0.5h-1.375c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h1.375  C16.193,12.5,16.417,12.276,16.417,12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.388,12c0-0.276-0.224-0.5-0.5-0.5H8.583c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h4.305  C13.165,12.5,13.388,12.276,13.388,12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.958,14.583h4.583c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5H9.958c-0.276,0-0.5,0.224-0.5,0.5  S9.682,14.583,9.958,14.583z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7ce2138e2f30acc9dbc0b0fbf7464e84.svg";
export { ForwardRef as ReactComponent };